// extracted by mini-css-extract-plugin
export var subWrapper = "index-module--subWrapper--BRglf";
export var title = "index-module--title--SBf1I";